// 旧 app/assets/javascripts/application.js のインライン実装。
// esbuild バンドルではモジュールスコープになるため、他ファイル
// (wage.js / earnings.js / expenses.js / matters.js)から参照される
// Select2Cascade は window に明示公開する。

//From https://gist.github.com/ajaxray/187e7c9a00666a7ffff52a8a69b8bf31
var Select2Cascade = ( function(window, $) {

  function Select2Cascade(parent, child, url, options) {
    var afterActions = [];

    // Register functions to be called after cascading data loading done
    this.then = function(callback) {
      afterActions.push(callback);
      return this;
    };

    parent.select2(options).on("change", function (e) {
      if($(this).val()) {
          child.prop("disabled", true);
          var _this = this;

          $.getJSON(url.replace(':parentId:', $(this).val()), function (items) {
              var newOptions = '<option value=""></option>';
              items.forEach(function (item) {
                  newOptions += '<option value="' + item['id'] + '">' + item['name'] + '</option>';
              });

              var childSelect2 = child.data('select2');
              var placeholder = childSelect2 && childSelect2.options.get('placeholder');

              child.select2('destroy').html(newOptions).prop("disabled", false)
                  .select2({allowClear: true, placeholder: placeholder || " "});

              afterActions.forEach(function (callback) {
                  callback(parent, child, items, options);
              });
          });
      }
    });
  }

  return Select2Cascade;

})( window, $);

window.Select2Cascade = Select2Cascade;

$(document).on("turbo:load", function(){
    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(event) {
        // Avoid following the href location when clicking
        event.preventDefault();
        // Avoid having the menu to close when clicking
        event.stopPropagation();
        // If a menu is already open we close it
        $('ul.dropdown-menu [data-toggle=dropdown]').parent().removeClass('open');
        // opening the one you clicked on
        $(this).parent().addClass('open');
    });

    $('#notification-link').on('click', function(event) {
        event.preventDefault();
        // If a menu is already open we close it
        $('#nav-content').collapse('hide');
    });

    $('#user-link').on('click', function(event) {
        event.preventDefault();
        // If a menu is already open we close it
        $('#nav-content').collapse('hide');
    });
    //
    // $('.dropdown-submenu a.dropdown-toggle').on("click", function(e){
    //     console.log('submenu')
    //     $(this).next('ul').toggle();
    //     e.preventDefault();
    //     e.stopPropagation();
    // });

    $(".toggle-next-div").on('click', function(){
        $("+div", this).toggle(200);
        $("span",this).toggleClass("fa-minus-square")
        $("span",this).toggleClass("fa-plus-square")
    });

    $('body').layout('fix');

    // disable mousewheel on a input number field when in focus
    // (to prevent Cromium browsers change the value when scrolling)
    $('form').on('focus', 'input[type=number]', function (e) {
        $(this).on('mousewheel.disableScroll', function (e) {
            e.preventDefault()
        })
    })
    $('form').on('blur', 'input[type=number]', function (e) {
        $(this).off('mousewheel.disableScroll')
    })
    $('[data-toggle="tooltip"]').tooltip()

    $('input.daterange').daterangepicker(
        {
            autoUpdateInput: false,
            locale: {
                format: 'YYYY/MM/DD',
                applyLabel: '適用',
                cancelLabel: 'クリア',
            }
        }
    );
    $('input.daterange').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY/MM/DD') + ' - ' + picker.endDate.format('YYYY/MM/DD'));
    });
    $('input.daterange').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
    });
});

// Don't send submit on pressing Enter key
$(function() {
    $(document).on("keypress", "input:not(.allow_submit)", function(event) {
        return event.which !== 13;
    });
});
